<template>
  <div class="mx-10 ma-5">
    <v-card
      class="pa-5"
      :style="{ border: '1px solid var(--primary-boarder-color)' }"
    >
      <PageTitleWithSearch
        :title="'Projects'"
        :btnName="'Add New Project'"
        :btnColor="'#00B3FF'"
        :btnRoute="'/projects/create'"
        :btnPermission="'project.create'"
        :btnEnable="true"
        :loading="loading"
        :search="search"
        @searchText="searchChange($event)"
      >
      </PageTitleWithSearch>
      <StatusFilter
        :title="'Filter by Status'"
        :loading="loading1 && !loading"
        @statusText="searchChange1($event)"
      ></StatusFilter>
      <v-divider></v-divider>
      <v-data-table
        v-if="!loading1 && projects"
        :headers="headers"
        :items="projects"
        :items-per-page="5"
        :hide-default-footer="true"
        :disable-sort="true"
        :disable-pagination="true"
        id="data-table"
      >
        <template v-slot:item="{ item, index }">
          <tr
            :class="index % 2 === 0 ? 'dark-row' : 'light-row'"
            class="custom-row"
          >
            <td>{{ item.project_code }}</td>
            <td class="text-left">
              <router-link
                :to="'/project/info/' + item.uuid"
                class="router-link font-weight-medium"
              >
                {{ item.project_name }}
              </router-link>
            </td>
            <td class="text-left">{{ item.customer.full_name }}</td>
            <td>{{ item.project_type ? item.project_type.name : "" }}</td>
            <td class="text-center" v-if="item.status">
              <v-chip
                class="ma-2"
                small
                :color="getStatusColors(item.status).chip"
                :text-color="getStatusColors(item.status).text"
              >
                {{ stringFormatting(item.status) }}
              </v-chip>
            </td>
            <td class="text-center">{{ item.start_date }}</td>
            <td class="text-center">{{ item.due_date }}</td>
            <td class="text-center">
              <v-btn
                v-if="hasPermission('project.edit')"
                color="#FFE0B2"
                :to="'/projects/edit/' + item.uuid"
                fab
                small
                style="box-shadow: none;"
                class="mx-2"
              >
                <v-icon small color="#FF9800"> mdi-pencil </v-icon>
              </v-btn>
              <v-btn
                v-if="hasPermission('project.delete')"
                small
                color="#FFCDD2"
                @click="dropMemberConfirm(item.uuid)"
                fab
                style="box-shadow: none;"
                class="mx-2"
              >
                <v-icon dark small color="var(--color-secondary-red)">
                  mdi-delete
                </v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-row class="my-1">
        <Pagination
          v-model="page"
          :loading="loading"
          :total="total"
          :page="page"
        ></Pagination>
      </v-row>
    </v-card>

    <ConfirmModal
      :text="'Do you want to drop this project?'"
      :title="'Drop Project'"
      :color="'red'"
      :confirmOpen="confirmOpen"
      @cancelConfirm="cancelConfirm()"
      @confirm="confirm()"
    ></ConfirmModal>
    <Snackbars
      :text="successMsg"
      :snackbar="snackbar"
      :color="'warning'"
      @classSnackbar="closeSnackbar"
    />
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");

import PageTitleWithSearch from "@/components/shared/PageTitleWithSearch";
import StatusFilter from "@/components/shared/StatusFilter";
import Snackbars from "@/components/shared/Snackbars";
import { ProjectService } from "@/services/project-service.js";
import { checkError } from "@/config/errors.js";
import Pagination from "@/components/shared/Pagination";
import ConfirmModal from "@/components/shared/ConfirmModal";
import { getStatusColors } from "@/utility/statusColors.js";

export default {
  name: "ProjectGrid",
  components: {
    PageTitleWithSearch,
    Snackbars,
    StatusFilter,
    Pagination,
    ConfirmModal,
  },
  data: function() {
    return {
      projects: [],
      page: 1,
      search: "",
      filterStatus: "",
      loading: false,
      loading1: false,
      role: localStorage.getItem("role") || null,
      total: 0,
      totalProject: 0,
      dropId: null,
      confirmOpen: false,
      snackbar: false,
      successMsg: "Project is not completed",
      defaultImage: require("@/assets/img/avatar.svg"),
      skill: 20,
      headers: [
        { text: "Project Code", value: "project_code" },
        { text: "Project Name", value: "project_name" },
        { text: "Customer", value: "budget" },
        { text: "Project Type", value: "budget" },
        { text: "Status", value: "status", align: "center" },
        { text: "Start Date", value: "start_date", align: "center" },
        { text: "Due Date", value: "due_date", align: "center" },
        { text: "Actions", value: "actions", align: "center" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      profile: "profile",
      hasPermission: "hasPermission",
    }),
  },
  mounted() {
    this.$store.dispatch("auth/getProfile");
    this.getProjectList();
  },

  watch: {
    search() {
      this.page = 1;
      this.getProjectList();
    },

    filterStatus() {
      this.getProjectList();
    },
    page() {
      this.getProjectList();
    },
    "$route.query.status": {
      handler() {
        this.searchChange1(this.$route.query.status || "");
      },
      immediate: true,
    },
  },

  methods: {
    getProjectList() {
      this.loading = true;
      ProjectService.getProjectList(this.search, this.filterStatus, this.page)
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.projects = response.data.data;
            this.total = response.data.meta.last_page || 0;
            this.totalProject = response.data.meta.total || 0;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.projects = [];
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },
    stringFormatting(str) {
      return str.replace(/_/g, " ");
    },
    getStatusColors(status) {
      return getStatusColors(status);
    },
    searchChange(value) {
      this.search = value;
    },

    searchChange1(value) {
      this.filterStatus = value;
    },

    closeSnackbar() {
      this.snackbar = false;
    },

    dropMemberConfirm(uuid) {
      this.dropId = uuid;
      this.confirmOpen = true;
    },

    cancelConfirm() {
      this.confirmOpen = false;
    },

    confirm() {
      this.confirmOpen = false;
      this.dropMember();
    },

    dropMember() {
      if (this.dropId) {
        this.loading = true;
        ProjectService.dropMember(this.dropId)
          .then((response) => {
            if (response.data == "Success") {
              this.loading = false;
              this.getProjectList();
            } else {
              this.loading = false;
              this.snackbar = true;
            }
          })
          .catch((error) => {
            this.loading = false;
            this.snackbar = true;
            let data = error.response.data;
            let errorOutput = checkError.errorFormatting(data);
            this.errors = errorOutput;
          });
      }
    },
  },
};
</script>
